import { Theme } from '@material-ui/core';

export const muiDividerOverrides = (theme: Theme): Theme['overrides'] => ({
  MuiDivider: {
    root: {
      backgroundColor: theme.palette.grey['400'],
    },
  },
});
